import React, {useEffect} from "react";
import {hasResponseError, loadSettings} from "../../api/requests";
import {ServerResponse, Settings} from "../../models/models";
import {
    getPreferredACPaymentMethod,
    getPreferredVDSPaymentMethod,
    getPreferredVRIPaymentMethod
} from "../../helpers/helpers";
import {RESPONSE_TYPES} from "../../constants";

const SubscriptionsContainerDataRefreshManager = ({
                                                      shouldRefresh,
                                                      setSettings,
                                                      setLoading,
                                                      setAppCenterData,
                                                      setVriData,
                                                      setVdsData,
                                                      setServerResponse,
                                                      setPreferredACPaymentMethod,
                                                      setPreferredVDSPaymentMethod,
                                                      setPreferredVRIPaymentMethod
                                                  }) => {
    useEffect(() => {
        setLoading(true);

        let isSubscribed = true;
        isSubscribed && loadSettings((response) => {
            if (hasResponseError(response)) {
                setLoading(false);
                setServerResponse(new ServerResponse(RESPONSE_TYPES.error, i18n.payments.error.genericTitle, response.data));
                return;
            }

            const allPaymentMethods = response.data.ac.allPaymentMethods;

            setSettings(new Settings(response));
            setAppCenterData(response.data.ac);
            setVriData(response.data.vri);
            setVdsData(response.data.vds);
            setPreferredACPaymentMethod(getPreferredACPaymentMethod(allPaymentMethods));
            setPreferredVDSPaymentMethod(getPreferredVDSPaymentMethod(allPaymentMethods));
            setPreferredVRIPaymentMethod(getPreferredVRIPaymentMethod(allPaymentMethods));
            setLoading(false);
        });
        return () => (isSubscribed = false);
    }, [shouldRefresh]);
    return <></>
}

export default SubscriptionsContainerDataRefreshManager;